export default {
  url_base_api: process.env.VUE_APP_ROOT_API,
  tokenType: 'Bearer',
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  showModalLogin: 'showModalLogin',
  configs: {},
}
